import { SectionType } from '#enums/mediaTypes.ts';
import { decodeId } from '#helpers/decodeId.ts';
import { encodeId } from '#helpers/encodeId.ts';
import { type QueryProps } from '../types.ts';

export const getVariables = ({ id, type }: QueryProps) => {
  if (type === SectionType.Season) {
    const decoded = decodeId<{ id: string; seasonNumber: number }>(String(id));
    return { seasonId: id, tvId: decoded.id };
  }

  if (type === SectionType.Episode) {
    const decoded = decodeId<{ episodeNumber: number; id: string; seasonNumber: number }>(String(id));

    return {
      episodeId: id,
      seasonId: encodeId({ id: decoded.id, seasonNumber: decoded.seasonNumber }),
      tvId: decoded.id,
    };
  }

  return { id };
};
